<template>
  <div>
    <div
      class="mb-2"
      v-html="qustion"
    />
    <v-layout
      align-center
      class="InputTracnkingNov ma-0"
    >
      <v-text-field
        v-model="inputVal"
        :disabled="hasReply || disabled"
        :placeholder="`請貼上${type}`"
        :hint="hint"
        outlined
        hide-details
        class="mt-0 pt-0"
        @keyup.enter="submit"
      />
      <v-btn
        v-if="!hasReply && !disabled"
        color="info"
        class="ml-2 mb-4"
        small
        @click="submit"
      >
        送出
      </v-btn>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: {
    detail: Object,
    parent: Object,
    type: String,
    qustion: String,
    hint: String,
    disabled: Boolean,
  },
  data () {
    return {
      inputVal: '',
      hasReply: false,
    }
  },
  computed: {
  },
  watch: {
    parent () {
      this.init()
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      const index = this.parent.replies.findIndex(item => item.content.indexOf(`[${this.detail.cid}]`) > -1)
      if (index > -1) {
        this.hasReply = true
        this.inputVal = this.parent.replies[index].content.split('：')[1]
        this.parent.replies.splice(index, 1)
      }
    },
    async submit () {
      if (!this.inputVal) return
      const res = await this.$store.dispatch('comment/createReply', {
        content: `回覆[${this.detail.cid}]${this.type}：${this.inputVal}`,
        upyunFiles: [],
        parent: this.parent.cid,
      })
      if (!res.data.error) {
        this.$emit('reload')
      }
    },
  },
}
</script>
<style lang="postcss">
.InputTracnkingNo {
  .v-input .v-label {
    font-size: 14px;
  }
}
</style>
